<template>
	<div class="row m-b-3">
		<div class="col-md-6 col-sm-6 col-xs-12 m-b-1 center font-sans">
			<!--			<div class="row">-->
			<!--				<div class="col-md-4">-->
			<!--					<img v-bind:src="'/img/mailing-lists/' + mailingList.image" class="img-responsive" alt="">-->
			<!--				</div>-->
			<!--				<div class="col-md-12 font-sans-bold center">-->
			{{ mailingList.name }}
			<!--				</div>-->
			<!--			</div>-->
		</div>
		<div class="col-md-6 col-sm-6 col-xs-12">
			<input type="hidden" v-bind:name="'mailing_lists[_ids][' + mailingList.id + ']'" v-bind:value="hiddenValue">
			<a href="" :class="buttonClasses" v-on:click.prevent="toggleSubscription()">
				Subscribe <i v-if="mailingList.selected" class="fa fa-check"></i>
			</a>
			<div v-if="hiddenValue === 35" class="form-group select required float-label-control">
				<select v-if="hiddenValue === 35"
						v-bind:name="'mailing_lists[' + mailingList.id + '][_joinData][dach_selection]'"
						v-bind:value="dachSelection"
					>
					<option value="CH">Schweiz</option>
					<option value="DE">Deutschland</option>
					<option value="AT">Österreich</option>
				</select>
				<label v-if="hiddenValue === 35" class="control-label">Land</label>
			</div>
			<a v-if="mailingList.has_preview" href="#" class="btn btn-default btn-block" data-toggle="modal"
			   :data-target="'#preview-' + mailingList.id">
				Preview
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MailingListSubscribe',
	props: {
		mailingList: {
			default: function () {
				return {}
			},
			required: true,
			type: Object
		},
		dachSelection: {
			default: function () {
				return ''
			},
			type: String
		}
	},
	methods: {
		toggleSubscription: function () {
			this.mailingList.selected = !this.mailingList.selected;
		}
	},
	computed: {
		isPreviewAvailable: function () {
			return this.mailingList.has_preview;
		},
		hiddenValue: function () {
			return this.mailingList.selected ? this.mailingList.id : '';
		},
		buttonClasses: function () {
			return {
				'btn': true,
				'btn-default': true,
				'btn-block': true,
				'm-b-1': true,
				'selected': this.mailingList.selected
			}
		}
	}
}
</script>

<style scoped>
.center {
	margin: auto;
	padding-top: 10px;
}
</style>
